import React from 'react';
import { Sidebar } from './Sidebar';
import { TopNavbar } from './TopNavbar';

export interface DashboardLayoutProps {
  children: React.ReactNode;
  currentView: string;
  onSelectView: (view: string) => void;
}

export const DashboardLayout: React.FC<DashboardLayoutProps> = ({
  children,
  currentView,
  onSelectView,
}) => {
  return (
    <div className="dashboard-grid">
      <Sidebar currentView={currentView} onSelectView={onSelectView} />
      <div className="main-content">
        <TopNavbar />
        <main style={{ padding: '32px', flex: 1 }}>{children}</main>
      </div>
    </div>
  );
};
